import React from 'react';

import FullLogo from '../assets/full-logo.svg';


function ErrorPage() {

    return (
        <div className="login-container login-consentowner">
            <div className="content">
                <div className="top d-flex align-items-center logo">
                    <img src={FullLogo} alt="Logo" />
                </div>

                <div className="login-area">
                    <div className="inner">
                        <h1>K&aelig;re bes&oslash;gende</h1>
                        <br />
                        <h3>Vi er ikke helt klar endnu!</h3>
                        <p>Vi er rigtig glade for din interesse for Mitsamtykke.</p>
                        <p>Vores portal er stadig under opbygning, men vi glæder os til snart at kunne byde dig velkommen
                            til et fuldt overblik over netop <em>dine</em> markedsførings&shy;samtykker.</p>
                        <p>Venlig hilsen<br />Mitsamtykke-teamet</p>
                    </div>
                </div>
            </div>
            <div className="image-container"></div>
        </div>
    );
}

export default ErrorPage;
